import { FunctionComponent } from "react"
import { useCreateAircraft } from "./AircraftQueries"
import { AircraftFormModal, AircraftFormValues } from "./AircraftFormModal"

interface AddAircraftModalProps {
    onSubmit: (response: { success: boolean; aircraftName: string }) => void
    onCancel: () => void
}

const AddAircraftModal: FunctionComponent<AddAircraftModalProps> = ({ onCancel, onSubmit }) => {
    const { createAircraft, isCreating } = useCreateAircraft()

    const handleSubmit = async (values: AircraftFormValues) => {
        try {
            await createAircraft({
                nickname: values.nickname || null,
                manufacturer: values.manufacturer,
                model: values.model || null,
                serial_number: values.serialNumber,
                registration_number: values.registrationNumber || null,
                purchased_at: values.purchasedAt || null,
                warranty_expires_at: values.warrantyExpiresAt || null,
                notes: values.notes || null,
                manual_status:
                    values.manualStatus === "maintenance_due" ? null : values.manualStatus,
            })
            onSubmit({ success: true, aircraftName: values.nickname })
        } catch {
            onSubmit({ success: false, aircraftName: values.nickname })
        }
    }

    return (
        <AircraftFormModal
            title="Create Drone"
            submitLabel="Create Drone"
            requireManufacturerAndModel
            isMutating={isCreating}
            onSubmit={handleSubmit}
            onCancel={onCancel}
        />
    )
}

export { AddAircraftModal }
